export const getKey = (args: { id: number; conId: number }) => `${args.conId}-${args.id}`;
